<template>
  <div id="contentTop" class="content">
    <div key="NOTICES" class="row">
      <div v-for="notice in notices" class="col-sm-12">
        <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
          <span data-notify="icon" class="fa fa-exclamation"></span>
          <span data-notify="message">{{notice.message}}</span>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
          <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        notices: null
      }
    },
    mounted () {
      var _this = this

      this.$api.getNotices(null, 'DASHBOARD')
        .then(response => {
          this.notices = response.data.content          
          // if(this.$store.state.username == 'candidate.referencing@experian.com') {
          //   if(this.notices == null) this.notices = []
          //   this.notices.push({message: 'Dear valued client, your invoice account has fallen into significant arears and currently some invoices are 60 days over the payment term of 30 days. Attempts have been made to resolve the outstanding invoices, sadly with no resolution. As such, unless resolved, this account will be transferred to Pre Paid Credit payment only as of the 30th January 2023. Please contact your Account Manager if you have any questions.'})
          // }
        })
      }
  }
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>
